export const prmi_principal = {
  name: 'Prmi Principal',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi.webp',
  logo_hidden: true,
  header_height: 250,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_deux_montagne = {
  name: 'Trajet Deux-Montagne La Source',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_1.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_saint_eustache_horizon = {
  name: "Trajet Saint-Eustache L'Horizon",
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_2.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_saint_eustache_brise = {
  name: 'Trajet Saint-Eustache La Brise',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_3.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_boisbriand_rivages = {
  name: 'Trajet Boisbriand Les rivages',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_4.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_boisbriand_remous = {
  name: 'Trajet Boisbriand Les Remous',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_5.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_rosemere_marecage = {
  name: 'Trajet Rosemère Les marécages',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_6.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_rosemere_marais = {
  name: 'Trajet Rosemère Les Marais',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_7.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_sainte_rose_observatoire = {
  name: "Trajet Sainte-Rose L'Observatoire",
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_8.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_sainte_rose_archipel = {
  name: "Trajet Sainte-Rose L'archipel",
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_9.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_sainte_rose_littoral = {
  name: 'Trajet Sainte-Rose Le littoral',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_10.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}

export const prmi_sainte_rose_quais = {
  name: 'Trajet Sainte-Rose Les Quais',
  body_background_color: '#D3D3D3',

  token_hidden: true,

  button_color: '#1d9ad6',
  button_no_border: false,
  button_radius: 10,
  button_border_width: 2,

  header_background_url: 'prmi/prmi_parcours_11.webp',
  logo_hidden: true,
  header_height: 350,
  header_full_height: true,

  button_half_border_color: '#1d9ad6',

  photobooth_background_color: '#1d9ad6',

  title_font: `Nunito`,
  title_weight: 700,
  subtitle_font: `Nunito`,
  subtitle_weight: 700,
  text_font: 'Open Sans',
  text_weight: 400,
}